import { render, staticRenderFns } from "./goodsSale.vue?vue&type=template&id=575c36b1&scoped=true"
import script from "./goodsSale.vue?vue&type=script&lang=ts"
export * from "./goodsSale.vue?vue&type=script&lang=ts"
import style0 from "./goodsSale.vue?vue&type=style&index=0&id=575c36b1&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575c36b1",
  null
  
)

export default component.exports